import { styled } from '@porsche-code/kado-styled-system/jsx';
import { PButton, PButtonProps } from '@porsche-design-system/components-react';
import {
  Children,
  cloneElement,
  HTMLAttributes,
  MouseEvent,
  ReactElement,
} from 'react';

const Wrapper = styled('div', {
  base: {
    all: 'unset',
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: '1fr',
    textAlign: 'center',
    gap: 'md',
  },
  variants: {
    variant: {
      primary: {
        backgroundColor: 'background.surface',
        borderRadius: 'xl',
        padding: 'sm',
      },
      secondary: {},
    },
  },
});

export type StatusControlChangeEvent = MouseEvent<HTMLButtonElement> & {
  target: HTMLButtonElement;
};

type StatusControlItemProps = {
  selected?: boolean;
} & PButtonProps;

export const StatusControlItem = ({
  children,
  selected,
  ...props
}: StatusControlItemProps) => (
  <PButton
    type="button"
    compact
    variant={selected ? 'primary' : 'secondary'}
    {...props}
  >
    {children}
  </PButton>
);

type StatusControlProps = {
  value?: string;
  onStatusControlChange?: (event: StatusControlChangeEvent) => void;
  children: ReactElement<StatusControlItemProps>[];
  variant?: 'primary' | 'secondary';
} & Omit<HTMLAttributes<HTMLDivElement>, 'children'>;

export const StatusControl = ({
  value,
  children,
  onStatusControlChange,
  variant = 'primary',
  ...props
}: StatusControlProps) => (
  <Wrapper variant={variant} {...props}>
    {Children.map(children, (item) => {
      const { value: itemValue, ...itemProps } = item.props;
      return cloneElement(item, {
        ...itemProps,
        onClick: onStatusControlChange,
        selected: itemValue === value,
        aria: { 'aria-pressed': itemValue === value ? 'true' : 'false' },
      });
    })}
  </Wrapper>
);
